{
  "title": "Vyberte si plán",
  "subtitle": "Kedykoľvek zmeňte alebo zrušte.",
  "upgrade": "Vylepšiť",
  "subscribe": "Predplatiť",
  "currentPlan": "Aktuálny plán",
  "includedInPlan": "Súčasť tvojho plánu",
  "restore": "Obnoviť nákupy",
  "cancel": "Zrušiť predplatné",
  "manage": "Spravovať predplatné",
  "loading": "Načítavam plány…",
  "unavailable": "Plány sú momentálne nedostupné.",
  "saveBadge": "Ušetri 20 %",
  "topUp": {
    "title": "Doplniť kredity",
    "subtitle": "Kúp si FYT kredity a pokračuj v chate s AI Coachom.",
    "balanceLabel": "Tvoj zostatok",
    "balance": "{{amount}} kreditov",
    "balanceUnknown": "—",
    "pack": "Balík kreditov",
    "packCredits": "{{amount}} kreditov",
    "buy": "Kúpiť",
    "unavailable": "Balíky kreditov sú momentálne nedostupné."
  },
  "period": {
    "monthly": "Mesačne",
    "yearly": "Ročne",
    "monthlyUnit": "za mesiac",
    "yearlyUnit": "za rok"
  },
  "plans": {
    "pro": {
      "name": "Pro",
      "tagline": "Pre seriózne sledovanie.",
      "features": {
        "barcodeScanning": "Skenovanie čiarových kódov jedál",
        "customFoods": "Vlastné jedlá + jednotky porcií",
        "customExercises": "Vlastné cviky + cieľové svaly",
        "personalRecords": "Osobné rekordy (top-3 medaily)",
        "favorites": "Obľúbené jedlá a cviky",
        "unlimitedHistory": "Neobmedzená história",
        "macroTargets": "Nastaviteľné makro a kalorické ciele",
        "restApi": "Prístup k REST API"
      }
    },
    "aiCoach": {
      "name": "AI Coach",
      "tagline": "Tvoj inteligentný asistent.",
      "features": {
        "mealChat": "Chat o jedle — hľadaj, zapíš a uprav v konverzácii",
        "workoutChat": "Chat o tréningu — tvorba a úpravy tréningov",
        "generalChat": "Všeobecný chat + viackrokový plánovač",
        "nutritionQa": "Personalizované otázky o výžive",
        "credits": "Meranie cez FYT kredity (500/mes. v cene)",
        "buyCredits": "Kúp extra kredity kedykoľvek",
        "mcpAccess": "Prístup k MCP serveru"
      }
    }
  }
}
